module.exports = __webpack_public_path__ + "static/media/module-prop-1.0b6ffc9f.svg";